const AUTH_DISPLAY_EVENT = "soal-auth-display-change";
const SUPER_ADMIN_IDS = new Set(["creator", "adminsoal"]);

function makeInitialsFromName(firstName = "", lastName = "", fallback = "") {
    const first = String(firstName || "").trim();
    const last = String(lastName || "").trim();

    if (first || last) {
        return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || "M";
    }

    const parts = String(fallback || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    if (parts.length >= 2) return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return "";
}

export function buildAuthDisplay({ role = "", idname = "", firstName = "", lastName = "", displayName = "" } = {}) {
    const cleanRole = String(role || "").toLowerCase();
    const cleanIdname = String(idname || "").toLowerCase();

    if (cleanRole === "admin" && SUPER_ADMIN_IDS.has(cleanIdname)) {
        return { label: "Admin", initials: "Admin" };
    }

    const safeName = String(displayName || `${firstName || ""} ${lastName || ""}`).trim();
    const initials = makeInitialsFromName(firstName, lastName, safeName || idname);

    return {
        label: initials || "Login",
        initials: initials || "",
    };
}

export function setAuthDisplay(data = {}) {
    const display = buildAuthDisplay(data);

    if (display.label && display.label !== "Login") {
        localStorage.setItem("auth_display_label", display.label);
        localStorage.setItem("auth_display_initials", display.initials || display.label);
    } else {
        clearAuthDisplay(false);
    }

    window.dispatchEvent(new CustomEvent(AUTH_DISPLAY_EVENT));
}

export function clearAuthDisplay(emit = true) {
    localStorage.removeItem("auth_display_label");
    localStorage.removeItem("auth_display_initials");
    if (emit) window.dispatchEvent(new CustomEvent(AUTH_DISPLAY_EVENT));
}

export function getAuthDisplay() {
    return {
        label: localStorage.getItem("auth_display_label") || "",
        initials: localStorage.getItem("auth_display_initials") || "",
    };
}

export { AUTH_DISPLAY_EVENT };
